import { ControlOutlined, ToolOutlined } from '@ant-design/icons';
import { ProTable, TableDropdown } from '@ant-design/pro-components';
import { Button, Checkbox, Col, Popover, Row, Select, Space, Table, Tooltip, Typography } from 'antd';
import axios from 'axios';
import { useState } from 'react';

const ProTable_ot = ({
    columns,
    expandable,
    request,
    headerTitle,
    check,
    setCheck,
    scroll,
    rowKey,
    rowSelection = {
        selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT]
    },
    pageSize,
    dataSource,
    editable,
    toolBarRender = () => [],
    options,
    onChange,
    extra_columns = [],
    set_extra_columns,
    manage_columns = true,
    actionRef,
    cardBordered = true,
    tableAlertRender = ({ selectedRowKeys, selectedRows, onCleanSelected }) => {
        return (
            <Space size={24}>
                <span>
                    已選 {selectedRowKeys.length} 項
                    <Typography.Link style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                        取消選擇
                    </Typography.Link>
                </span>
            </Space>
        );
    },
    tableAlertOptionRender = () => {
        return (
            <Space size={16}>
                <Typography.Link>匯出資料</Typography.Link>
            </Space>
        )
    }
}) => {
    const ChangeColumnsCheckbox = ({ columns, check, setCheck }) => {
        const onChange = (list) => {
            setCheck(list);
        }
        return (<Checkbox.Group
            style={{
                width: '100%',
            }}
            value={check}
            onChange={onChange}
        >
            <Row>
                {
                    columns.map((map_item, index) => {
                        const disabled = map_item.disabled || false
                        return <Col span={12}>
                            <Checkbox value={map_item.key} disabled={disabled}>{map_item.title}</Checkbox>
                        </Col>
                    })
                }
            </Row>
        </Checkbox.Group>)
    }
    return (<>
        <ProTable
            rowSelection={rowSelection}
            expandable={expandable}
            columns={[
                ...columns.map(map_item => ({ sorter: { multiple: 1 }, ...map_item })),
                ...extra_columns,
            ]}
            actionRef={actionRef}
            cardBordered={cardBordered}
            dataSource={dataSource}
            request={request}
            editable={{
                type: 'multiple',
                ...editable
            }}
            columnsState={{
                persistenceKey: 'pro-table-singe-demos',
                persistenceType: 'localStorage',
                onChange(value) {
                    // console.log('value: ', value);
                },
            }}
            tableAlertRender={tableAlertRender}
            tableAlertOptionRender={tableAlertOptionRender}
            rowKey={rowKey}
            search={false}
            options={{
                setting: {
                    listsHeight: 400,
                },
                search: {
                    suffix: (<>
                        <Popover
                            overlayStyle={{
                                width: "40vw"
                            }}
                            placement="topLeft"
                            title={"選擇欲搜尋欄位"}
                            content={<ChangeColumnsCheckbox columns={columns} check={check} setCheck={setCheck} />}
                        >
                            <ControlOutlined />
                        </Popover>
                    </>),
                },
                ...options
            }}
            pagination={{
                pageSize: pageSize,
                showSizeChanger: true,
            }}
            onChange={onChange}
            tableLayout={'fixed'}
            scroll={scroll}
            dateFormatter="string"
            headerTitle={headerTitle}
            toolBarRender={() => [
                manage_columns && (<>
                    <ManageColumns columns={extra_columns} onChange={(e) => {
                        set_extra_columns(e.map(map_item => {
                            return {
                                title: map_item,
                                dataIndex: map_item,
                                key: map_item,
                                render: (_, record) => record.number * record.comments
                            }
                        }))
                    }} />
                </>),
                ...toolBarRender()
            ]}
            
        />
    </>)
}
export default ProTable_ot;

const ManageColumns = (props) => {
    const extra_columns = props.extra_columns || [];
    const set_extra_columns = props.set_extra_columns || [];
    const [show, set_show] = useState(false);
    const [selected, set_selected] = useState([])
    return (<>
        <Tooltip
            title={'點擊展開'}
        >
            <Button type='link' icon={<ToolOutlined style={{ verticalAlign: 'middle' }} />}
                onClick={() => set_show(prev => !prev)}
            >管理欄位</Button>
        </Tooltip>
        <Select
            hidden={!(show)}
            mode="tags"
            options={extra_columns}
            dropdownStyle={{ minWidth: "200px" }}
            placement={'bottomRight'}
            onChange={(e) => {
                set_selected(e)
                props.onChange(e);
            }}
            allowClear
            maxTagCount={5}
        />
    </>)
}
const Demo = ({

}) => {
    const [data, set_data] = useState([]);
    const columns = [
        {
            title: '項次',
            dataIndex: '項次',
            valueType: 'indexBorder',
            width: 48
        },
        {
            title: '產品代號',
            // dataIndex: '產品代號',
            dataIndex: 'id',
            key: '產品代號',
            copyable: true,
        },
        {
            title: '產品名稱',
            // dataIndex: '產品名稱',
            dataIndex: 'title',
            ellipsis: true,
            tip: '滑鼠移至上方可以顯示全名',
        },
        {
            title: '單位',
            dataIndex: '單位',
            key: '單位',
            render: (_, record) => record.author_association
        },
        {
            title: '進／出貨數量',
            dataIndex: '進／出貨數量',
            key: '進／出貨數量',
            render: (_, record) => record.comments
        },
        {
            title: '單價',
            dataIndex: '單價',
            key: '單價',
            render: (_, record) => record.number
        },
        {
            title: '總價',
            dataIndex: '總價',
            key: '總價',
            render: (_, record) => record.number * record.comments
        },
        {
            title: '操作',
            valueType: 'option',
            key: 'option',
            fixed: 'right',
            render: (text, record, _, action) => [
                <a
                    key="editable"
                    onClick={() => {
                        action?.startEditable?.(record.key);
                    }}
                >
                    編輯
                </a>,
                <a href={record.url} target="_blank" rel="noopener noreferrer" key="view">
                    詳細資訊
                </a>,
                <TableDropdown
                    key="actionGroup"
                    onSelect={() => action?.reload()}
                    menus={[
                        { key: 'copy', name: '複製' },
                        { key: 'delete', name: '刪除' },
                    ]}
                />,
            ],
        },
    ];
    const [check, set_check] = useState([])
    const [extra_columns, set_extra_columns] = useState([]);
    return (<>
        <ProTable_ot
            headerTitle={<></>}
            request={async (params = {}, sort, filter) => {
                return axios.get('https://proapi.azurewebsites.net/github/issues',
                    {
                        params
                    }
                )
                    .then(response => {
                        return {
                            ...response.data,
                        }
                    })
            }}
            columns={columns}
            check={check}
            setCheck={set_check}
            rowKey={'id'}
            selections={{
                onChange: (index_, data_) => set_data(data_)
            }}
            toolBarRender={() => []}
            extra_columns={extra_columns}
            set_extra_columns={set_extra_columns}
            manage_columns={false}
            rowSelection={{
                selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT],
            }}
        />
    </>)
}